import { useMemo } from 'react';

import { FolderIcon, HelpIcon } from '@braskai/icons';
import { useLocation } from 'react-router-dom';

import type { NavigationItemProps } from '@/shared/ui/NavigationItem';

import { HELP_CENTER_LINK, WHITE_LABEL_SUPPORT_LINK } from '@/shared/constants/docLinks';
import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments/wl';
import { ChatIcon, showChat } from '@/shared/thirdParty/hubSpot';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

type Params = {
  onAction?: () => void;
};

export const useRecordingSidebarNavigation = ({ onAction }: Params = {}) => {
  const { pathname } = useLocation();

  const mainNavigation = useMemo<NavigationItemProps[]>(
    () => [
      {
        title: 'Projects',
        dataTestId: 'recording-sidebar-projects',
        icon: <FolderIcon height={16} width={16} />,
        path: PATHS.homepage,
        selected: pathname === PATHS.homepage,
        onClick: onAction,
      },
    ],
    [onAction, pathname],
  );

  const bottomNavigation = useMemo<NavigationItemProps[]>(() => {
    if (IS_WHITE_LABEL) {
      return [
        {
          title: 'Get help',
          dataTestId: 'recording-sidebar-get-help',
          icon: <HelpIcon height={16} width={16} />,
          onClick: () => {
            window.open(`mailto:${WHITE_LABEL_SUPPORT_LINK}`);
            onAction?.();
          },
        },
      ];
    }

    return [
      {
        title: 'Help center',
        dataTestId: 'recording-sidebar-help-center',
        icon: <HelpIcon height={16} width={16} />,
        onClick: () => {
          MixpanelEvents.helpCenterClick();
          window.open(HELP_CENTER_LINK);
          onAction?.();
        },
      },
      {
        title: 'Get help',
        dataTestId: 'recording-sidebar-get-help',
        icon: <ChatIcon height={16} width={16} />,
        onClick: () => {
          MixpanelEvents.getHelpClick();
          showChat();
          onAction?.();
        },
      },
    ];
  }, [onAction]);

  return {
    bottomNavigation,
    isAccountActive: pathname === `/${PATHS.account}`,
    mainNavigation,
  };
};
